export default () => {
  const { minimumLoyaltyPoints } = useAppConfig().components.checkout.paymentLoyalty
  const { details, hasNewsletterSubscription, get: getProfile } = useUserStore()
  const loyalty = useLoyaltyStore()
  const auth = useAuthStore()

  /**
   * Many values needed for analytics are not available immediately on page load.
   * Here we wait for the values to be available before resolving.
   */
  const getUserEventData = async (overrideEmail?: string, consumerId?: string) => {
    let loyaltyMemberId = auth.memberId
    try {
      if (!loyaltyMemberId) loyaltyMemberId = await auth.getMemberId()
    }
    catch (err) {
      log.error(`[@domains/commerce/utils/gtm.ts] Error: ${err}`)
    }

    if (auth.loggedIn) {
      await Promise.all([
        !details ? getProfile() : Promise.resolve(),
        !loyalty.rewardsRequested ? loyalty.getRewards() : until(() => loyalty.rewardsPending).toBe(false),
        loyalty.vouchersStatus === 'idle' ? loyalty.getVouchers() : until(() => loyalty.vouchersPending).toBe(false),
      ])
    }

    const email = overrideEmail || details?.email

    const defaultVouchers = { applicableLoyaltyVouchers: [], currentLoyaltyPoints: 0 }
    const { applicableLoyaltyVouchers, currentLoyaltyPoints } = loyalty.vouchers || defaultVouchers
    const hasAvailableVouchers = applicableLoyaltyVouchers.some(({ available, eligible }) => available && eligible)
    const hasMinLoyaltyPoints = currentLoyaltyPoints >= (applicableLoyaltyVouchers[0]?.points || minimumLoyaltyPoints)

    return {
      ...(loyaltyMemberId && {
        'loyaltyMember-id': loyaltyMemberId,
      }),
      ...(email && {
        'encoded-email': btoa(email),
        'encoded-email-sha': await generateHashHex(email)
      }),
      ...(auth.loggedIn && {
        // if the subscription with the type "Newsletter" has an doubleOptin value as true, we can use this identifier to push data to the data layer https://digital.vfc.com/jira/browse/GLOBAL15-100442
        'nl-subscription': hasNewsletterSubscription,
        'rewardsAvailable': loyalty.rewardsAvailable.length > 0 || (hasAvailableVouchers && hasMinLoyaltyPoints),
      }),
      ...(overrideEmail && {
        'consumer-id': consumerId
      })
    }
  }

  return {
    getUserEventData,
  }
}
